/** Feste Farbwerte nur hier: Vorschläge für die Akzentfarbe und Referenzen für die Kontrastprüfung (Einstellungen › Laden). */
export const BRANDING = {
  vorschlaege: ["#4b3baa", "#1f6f78", "#2f5d50", "#7a3e3e", "#8a5a1e"],
  /** Heller Seitenhintergrund (Token --surface, hell) und Weiß für Schrift auf der Farbe. */
  hintergrundHell: "#f7f6fb",
  weiss: "#ffffff",
} as const;
